import {
  EMPTY_EVENT_CONFIG,
  type EventConfig,
  normalizeUpgradeDiscount,
} from '@rb/shared/event-config';
import { pickFlavor, wrapFlavors } from '@rb/shared/r2-flavor';
import { callEdgeFunction } from '../supabase.client';

export function emptyAdminConfig(): EventConfig {
  return structuredClone(EMPTY_EVENT_CONFIG);
}

/** 발행본을 폼이 안전하게 편집하도록 신규 골드/루비 필드를 정규화해 채운다. */
function normalizeFetched(config: EventConfig): EventConfig {
  const resolved = normalizeUpgradeDiscount(config.discount);
  return {
    ...config,
    discount: {
      ...emptyAdminConfig().discount,
      ...config.discount,
      upgradeGold: resolved.gold,
      upgradeGoldPct: resolved.goldPct,
      upgradeRuby: resolved.ruby,
      upgradeRubyPct: resolved.rubyPct,
    },
    starReward: { ...emptyAdminConfig().starReward, ...config.starReward },
  };
}

/** 현재 채널의 발행본 GET. 미발행이면 빈 폼 config. */
export async function fetchEventConfig(channel: string): Promise<EventConfig> {
  const res = await callEdgeFunction<{ config: EventConfig | null }>('event-config', { channel });
  return res.config ? normalizeFetched(res.config) : emptyAdminConfig();
}

/** 폼 config 를 채널에 발행. */
export async function publishEventConfig(channel: string, config: EventConfig): Promise<void> {
  await callEdgeFunction('event-config', { channel, config });
}

/** 발행본을 web2/web3 로 분리해 폼에 시드. 레거시 평탄은 양쪽 동일 시드. */
export async function fetchEventConfigFlavored(
  channel: string
): Promise<{ web2: EventConfig; web3: EventConfig }> {
  const res = await callEdgeFunction<{ config: unknown | null }>('event-config', { channel });
  if (!res.config) return { web2: emptyAdminConfig(), web3: emptyAdminConfig() };
  const web2 = normalizeFetched(pickFlavor<EventConfig>(res.config, 'web2'));
  const web3 = normalizeFetched(pickFlavor<EventConfig>(res.config, 'web3'));
  return { web2, web3 };
}

/** 두 flavor 섹션을 nested 로 묶어 발행. */
export async function publishEventConfigFlavored(
  channel: string,
  flavored: { web2: EventConfig; web3: EventConfig }
): Promise<void> {
  await callEdgeFunction('event-config', {
    channel,
    config: wrapFlavors(flavored.web2, flavored.web3),
  });
}
